import React from 'react';
import './PerformanceSection.css';

interface PerformanceHighlight {
  number: string;
  text: string;
}

interface PerformanceSectionProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  highlights: PerformanceHighlight[];
}

const PerformanceSection: React.FC<PerformanceSectionProps> = ({
  eyebrow,
  title,
  subtitle,
  highlights
}) => {
  return (
    <section className="performance-section">
      <div className="section-container">
        <div className="performance-header">
          {eyebrow && <div className="eyebrow centered">{eyebrow}</div>}
          <h2>{title}</h2>
          {subtitle && <p className="performance-subtitle">{subtitle}</p>}
        </div>
        <div className="performance-highlights">
          {highlights.map((highlight, index) => (
            <div key={index} className="perf-metric">
              <div className="perf-metric-number">{highlight.number}</div>
              <div className="perf-metric-text">{highlight.text}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PerformanceSection;
